import { COVERGO_SAAS_PROD } from "../consts.js"

export const moneysmart = {
	// CoverGo PROD
	"moneysmart-dev-studio.quote.hk": {
		appConfig: { tenantId: "moneysmart_sandbox_uat", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
